import React from "react"
import VerticalTab from "../../../components/Tab/VerticalTab"
import Card from "../../../components/Card/Card"

const SideBar = ({ setActiveTab, activeTab }) => {
  return (
    <Card className="flex flex-col px-6 py-5 w-[350px] gap-4">
      <div className="flex flex-col gap-4 text-text-secondary text-md">
        <VerticalTab setActiveTab={setActiveTab} activeTab={activeTab} currentTab="contactGroups" title="Contact Groups" />
        <VerticalTab setActiveTab={setActiveTab} activeTab={activeTab} currentTab="workflowControl" title="Workflow Control" />
        <VerticalTab setActiveTab={setActiveTab} activeTab={activeTab} currentTab="companySettings" title="Company Settings" />
        <VerticalTab setActiveTab={setActiveTab} activeTab={activeTab} currentTab="paymentExport" title="Payment Export" />
        <VerticalTab setActiveTab={setActiveTab} activeTab={activeTab} currentTab="paymentProcessing" title="Payment Processing" />
        <VerticalTab setActiveTab={setActiveTab} activeTab={activeTab} currentTab="enrolledReport" title="Enrolled Report" />
      </div>
    </Card>
  )
}

export default SideBar
